exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html{position:relative;min-height:100%}body{margin-bottom:80px}.navbar{margin-bottom:0px}.navbar-brand{padding:5px 15px}.navbar-brand img{height:100%}#content{margin-bottom:20px}.container .text-muted{margin:20px 0}code{font-size:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./modules/base/css/core.scss
// module id = 704
// module chunks = 0